module.exports = __webpack_public_path__ + "static/img/spadac.3ee6c9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spadac.png
// module id = Ep1n
// module chunks = 1